import { fetcher } from '@commenda/utils';

export interface UnlinkAdminHubSpotCompanyParams {
  companyId: number;
}

export async function unlinkAdminHubSpotCompany({
  companyId,
}: UnlinkAdminHubSpotCompanyParams) {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/hubspot`,
    { method: 'DELETE' }
  );

  if (!response.ok) throw new Error('Failed to unlink HubSpot company');
  return response.json();
}
